import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { keyframes } from '@mui/system';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// const spin = keyframes`
//   0% {
//     transform: rotate(45deg);
//   }
//   100% {
//     transform: rotate(405deg);
//   }
// `;

const spin2 = keyframes`
  0% {
    transform: rotate(45deg);
  }
  10% {
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(405deg);
  }
`;

const spin3 = keyframes`
  0% {
    transform: rotate(45deg);
  }
  20% {
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(405deg);
  }
`;

const spin4 = keyframes`
  0% {
    transform: rotate(45deg);
  }
  30% {
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(405deg);
  }
`;

const colorRightHalf = '#E3DB00'
const colorLeftHalf = '#F6F4BC'

// const ExternalCircle = styled(Box)(({ theme }) => ({
//   width: '15.5vh',
//   height: '15.5vh',
//   backgroundColor: 'none',
//   borderRadius: '50%',
//   border: '0.85vh solid',
//   borderColor: theme.palette.semantic.confirm,
//   margin: 'auto',
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   bottom: 0,
//   right: 0,
//   borderBottomColor: theme.palette.semantic.confirm2,
//   borderLeftColor: theme.palette.semantic.confirm2,
//   animation: `${spin} 4s infinite ease`,
//   transform: 'rotate(45deg)',
// }));

const MiddleCircle = styled(Box)(({ theme }) => ({
  width: '12.5vh',
  height: '12.5vh',
  backgroundColor: 'none',
  borderRadius: '50%',
  border: '0.85vh solid',
  borderColor: colorRightHalf,
  margin: 'auto',
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  borderBottomColor: colorLeftHalf,
  borderLeftColor: colorLeftHalf,
  animation: `${spin2} 4s infinite ease`,
  transform: 'rotate(45deg)',
}));

const InternalCircle = styled(Box)(({ theme }) => ({
  width: '9.5vh',
  height: '9.5vh',
  backgroundColor: 'none',
  borderRadius: '50%',
  border: '0.85vh solid',
  borderColor: colorRightHalf,
  margin: 'auto',
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  borderBottomColor: colorLeftHalf,
  borderLeftColor: colorLeftHalf,
  animation: `${spin3} 4s infinite ease`,
  transform: 'rotate(45deg)',
}));

const Center = styled(Box)(({ theme }) => ({
  width: '6.5vh',
  height: '6.5vh',
  backgroundColor: 'none',
  borderRadius: '50%',
  border: '0.85vh solid',
  borderColor: colorRightHalf,
  margin: 'auto',
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  borderBottomColor: colorLeftHalf,
  borderLeftColor: colorLeftHalf,
  animation: `${spin4} 4s infinite ease`,
  transform: 'rotate(45deg)',
}));

const LoadingText = styled(Typography)(({ theme }) => ({
  margin: 'auto',
  position: 'absolute',
  top: '60%',
  left: 0,
  bottom: 0,
  right: 0,
  fontWeight: 500,
  fontSize: '3vh',
  textAlign: 'center',
}));

const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.text.t100,
  color: theme.palette.neutral.white,
}));

const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  color: theme.palette.text.t100,
  marginTop: 20,
}));

export {
  // ExternalCircle,
  MiddleCircle,
  InternalCircle,
  Center,
  LoadingText,
  CustomDialogTitle,
  CustomDialogContent,
};
